import { render } from "./RegistrarProveedorModal.vue?vue&type=template&id=7b099e70&scoped=true"
import script from "./RegistrarProveedorModal.vue?vue&type=script&lang=js"
export * from "./RegistrarProveedorModal.vue?vue&type=script&lang=js"

import "./RegistrarProveedorModal.vue?vue&type=style&index=0&id=7b099e70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b099e70"]])

export default __exports__